//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import { useState } from 'react'

import SidebarSection from 'components/Shared/Sidebar/SidebarSection/Index'
import SidebarText from 'components/Shared/Sidebar/SidebarText/Index'
import JsonViewer from 'components/Shared/JsonViewer/Index'
import JsonViewerModal from 'components/Shared/JsonViewerModal/Index'

import { formatJson } from 'utils/strings'

const SidebarSectionJson = ({ title, json }) => {
  const [jsonViewerModalVisible, setJsonViewerModalVisible] = useState(false)

  const formattedJson = formatJson(json)
  const noData = !formattedJson && formattedJson !== 0

  if (noData) {
    return (
      <SidebarSection title={title}>
        <SidebarText text={null} />
      </SidebarSection>
    )
  }

  const openJsonViewerModal = () => {
    setJsonViewerModalVisible(true)
  }

  const closeJsonViewerModal = () => {
    setJsonViewerModalVisible(false)
  }

  return (
    <SidebarSection
      title={title}
      copyText={formattedJson}
      expandedContent={formattedJson}
      onExpandContent={openJsonViewerModal}
    >
      <JsonViewerModal
        key={title}
        isOpen={jsonViewerModalVisible}
        closeModal={closeJsonViewerModal}
        title={title}
        json={formattedJson}
      />
      {noData
        ? <SidebarText text={null} />
        : (
          <JsonViewer
            json={formattedJson}
            onMoreClick={openJsonViewerModal}
            maxLines={16}
          />
          )
        }
    </SidebarSection>
  )
}

SidebarSectionJson.propTypes = {
  title: PropTypes.string,
  json: PropTypes.string,
}

export default SidebarSectionJson
